function brauchbar(r) {
    return r.kind === 'preview' && r.status === 'ready' && Boolean(r.url) && !r.cleaned_at;
}
/** Der neueste gerechnete Film, der zu dieser Fassung des Schnitts gehört. */
export function passenderFilm(renders, rev) {
    const passend = renders.filter((r) => brauchbar(r) && r.rev === rev);
    if (passend.length === 0)
        return null;
    return [...passend].sort((a, b) => b.created_at.localeCompare(a.created_at))[0];
}
/**
 * Gibt es einen Film, der nur veraltet ist? Dann lohnt der Hinweis „neu
 * rechnen“ -- im Unterschied zu „es gibt keinen“.
 */
export function filmVeraltet(renders, rev) {
    const alte = renders.filter((r) => brauchbar(r) && r.rev < rev);
    if (alte.length === 0)
        return null;
    return [...alte].sort((a, b) => b.rev - a.rev || b.created_at.localeCompare(a.created_at))[0];
}
//# sourceMappingURL=film.js.map